import { render } from "./save-query-modal.pug?vue&type=template&id=46fb4c12&lang=pug&external"
import script from "./save-query-modal.js?vue&type=script&lang=js&external"
export * from "./save-query-modal.js?vue&type=script&lang=js&external"

import "./save-query-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__